import { createSlice } from "@reduxjs/toolkit";

const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    Invoice: [],
  },
  reducers: {
    invoiceSuccess: (state, action) => {
      state.Invoice = [...action.payload];
    },
    clearInvoice: (state) => {
      state.Invoice = [];
    },
  },
});

export const { clearInvoice, invoiceSuccess } = invoiceSlice.actions;
export default invoiceSlice.reducer;
